import React, { useEffect, useRef, useState } from 'react';
import { KTSVG } from '../../../../../_mexablock/helpers';
import {
  getToday,
  getYesterday,
  getThisWeek,
  getLast15Days,
  getThisMonth,
  getLastMonth,
  formatDateMonthGuinMedio,
} from '../../../../../_mexablock/helpers';

type Props = {
  valueInit: string;
  valueEnd: string;
  setInitDate: (v: string) => void;
  setEndDate: (v: string) => void;
  onCleanFilter: () => void;
  changeName: boolean;
};

const FilterMov: React.FC<Props> = ({
  valueInit,
  valueEnd,
  setInitDate,
  setEndDate,
  onCleanFilter,
  changeName,
}) => {
  const dateInputRef = useRef<HTMLInputElement | null>(null);
  const [showCalendar, setShowCalendar] = useState<boolean>(false);
  const [nameDate, setNameDate] = useState<string>('Fecha');

  const setRange = (start: Date, end: Date, label: string) => {
    setInitDate(formatDateMonthGuinMedio(start.toISOString()));
    setEndDate(formatDateMonthGuinMedio(end.toISOString()));
    setNameDate(label);
    setShowCalendar(false);
  };

  useEffect(() => {
    if (changeName) {
      setNameDate('Fecha');
    }
  }, [changeName]);

  return (
    <div className="card-title align-items-start flex-column">
      <button
        type="button"
        className="btn btn-sm btn-primary w-100"
        data-kt-menu-trigger="click"
        data-kt-menu-placement="left-start"
        data-kt-menu-flip="top-end"
      >
        {nameDate}
        <KTSVG
          path="/media/icons/duotune/general/gen014.svg"
          className="svg-icon-5 svg-icon-gray-500 ms-2"
        />
      </button>

      <div
        className="menu menu-sub menu-sub-dropdown w-250px w-md-400px"
        data-kt-menu="true"
      >
        <div className="px-7 py-5">
          <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
        </div>

        <div className="separator border-gray-200"></div>

        <div className="px-7 py-5">
          {/* Botones rápidos */}
          <div className="mb-5">
            <button
              className="btn btn-sm btn-light-primary w-100"
              type="button"
              onClick={() => {
                const { start, end } = getToday();
                setRange(start, end, 'Hoy');
              }}
            >
              Hoy
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                const { start, end } = getYesterday();
                setRange(start, end, 'Ayer');
              }}
            >
              Ayer
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                const { start, end } = getThisWeek();
                setRange(start, end, 'Esta semana');
              }}
            >
              Esta semana
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                const { start, end } = getLast15Days();
                setRange(start, end, 'Últimos 15 días');
              }}
            >
              Últimos 15 días
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                const { start, end } = getThisMonth();
                setRange(start, end, 'Este mes');
              }}
            >
              Este mes
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                const { start, end } = getLastMonth();
                setRange(start, end, 'Mes pasado');
              }}
            >
              Mes pasado
            </button>
          </div>
          <div className="mb-5">
            <button
              type="button"
              className="btn btn-sm btn-light-primary w-100"
              onClick={() => {
                setShowCalendar(true);
                setNameDate('Rango de fechas');
              }}
            >
              Rango de fechas
            </button>
          </div>

          {/* Calendario manual */}
          {showCalendar && (
            <div className="row">
              <div className="mb-5 col-6">
                <label className="form-label fw-bold">Fecha inicial:</label>
                <input
                  type="date"
                  className="form-control"
                  value={valueInit || ''}
                  onChange={(e) => setInitDate(e.target.value)}
                />
              </div>
              <div className="mb-5 col-6">
                <label className="form-label fw-bold">Fecha fin:</label>
                <input
                  type="date"
                  className="form-control"
                  value={valueEnd || ''}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          )}

          {/* <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-sm btn-white btn-active-light-primary me-2"
              onClick={() => {
                setNameDate('Fecha');
                setInitDate('');
                setEndDate('');
                setShowCalendar(false);
                onCleanFilter();
              }}
            >
              Limpiar
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export { FilterMov };
